export default __webpack_public_path__ + "static/media/eyes.f6f926c9.svg";